import { useState, useContext, useEffect } from 'react';
import { PaxContext } from '../../utils/context/checkoutContext';

export const CurrencySwitcherToggle = () => {
  const { currency, updateCurrency }: any = useContext(PaxContext);

  // Get currency and updateCurrency from context
  const [selectedCurrency, setSelectedCurrency] = useState(currency); // Set the initial state based on context

  useEffect(() => {
    setSelectedCurrency(currency);
  }, [currency]);

  const handleCurrencyChange = (newCurrency: string) => {
    setSelectedCurrency(newCurrency); // Update the local state
    updateCurrency(newCurrency); // Update the context
  };

  return (
    <div className="flex items-center justify-between w-[90px] sm:w-[120px] h-[35px] sm:h-[40px] rounded-full border border-gray-300 p-1">
      <button
        onClick={() => handleCurrencyChange('USD')}
        className={`${
          selectedCurrency === 'USD'
            ? 'bg-primary text-white text-[12px] sm:text-[15px] font-bold'
            : 'bg-white text-black text-[13px] sm:text-[16px] font-semibold'
        } text-[13px] sm:text-[15px] w-[50%] h-full flex items-center justify-center rounded-full transition-all duration-300 ease-in-out`}
      >
        USD
      </button>

      <button
        onClick={() => handleCurrencyChange('CAD')}
        className={`${
          selectedCurrency === 'CAD'
            ? 'bg-primary text-white text-[12px] sm:text-[15px] font-bold'
            : 'bg-white text-black text-[13px] sm:text-[16px] font-semibold'
        }  w-[50%] h-full flex items-center justify-center rounded-full transition-all duration-300 ease-in-out`}
      >
        CAD
      </button>
    </div>
  );
};
